import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CammsNavigateHubService } from './camms-navigate-hub.service';

@Component({
    selector: 'camms-navigate-hub',
    imports: [],
    templateUrl: 'camms-navigate-hub.component.html',
    styles: [
        `
            html,
            body {
                height: 100%;
                margin: 0;
                padding: 0;
            }
            .centered {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
            }
            img {
                height: 70px;
            }
        `,
    ],
})
export class CammsNavigateHubComponent implements OnInit {
    invalidToken: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private cammsNavigateHubService: CammsNavigateHubService,
    ) {
        const hasAppURL = this.route.snapshot.queryParamMap.has('AppURL');
        if (hasAppURL) {
            var appURL = this.route.snapshot.queryParamMap.get('AppURL');
            // Get current query parameters
            const currentParams = { ...this.route.snapshot.queryParams };
            // Get the decrypted token to pass for old apps (product navigation etc.)
            delete currentParams['AppURL'];
            // Append new query parameters

            let accessTokenValue = '';

            let accessToken = this.cammsNavigateHubService.getAuthToken(false);
            if (accessToken && accessToken.length > 0) {
                accessTokenValue = accessToken[0];
            } else {
                accessTokenValue =
                    this.cammsNavigateHubService.getAccessToken();
            }

            if (accessTokenValue == 'TOKEN_IS_NOT_AVAILABLE') {
                this.invalidToken = true;
            } else {
                if (appURL) {
                    appURL = appURL.replace(
                        'NavigateToNewIRM',
                        accessTokenValue,
                    );
                    window.location.href = this.constructUrlWithParams(
                        appURL,
                        currentParams,
                    );
                }
            }
        } else {
            this.invalidToken = true;
        }
    }

    ngOnInit(): void {}

    // private constructUrlWithParams(url: string, queryParams: any): string {
    //   const queryString = Object.keys(queryParams)
    //     .map((key) => `${key}=${queryParams[key]}`)
    //     .join('&');

    //     let x = url + (queryString ? `?${queryString}` : '');
    //   return url + (queryString ? `?${queryString}` : '');
    // }

    private constructUrlWithParams(url: string, queryParams: any): string {
        const queryString = Object.keys(queryParams)
            .map((key) => `${key}=${queryParams[key]}`)
            .join('&');

        // Check if the URL already contains a '?' for product navigation urls
        const separator = url.includes('?') ? '&' : '?';

        let x = url + (queryString ? `${separator}${queryString}` : '');
        return x;
    }
}
